/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_ClaudeInputs */

const en_node_claude = /** @type {(inputs: Node_ClaudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude`)
};

/**
* | output |
* | --- |
* | "Claude" |
*
* @param {Node_ClaudeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_claude = /** @type {((inputs?: Node_ClaudeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_ClaudeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_claude(inputs)
});